import ModelState, {related, Model, localised} from './_util/model';

class BookingModel extends Model {
  @related('speciality_id', false, 'specialities') speciality;
}

@localised
class BookingsState extends ModelState {
  sanitizeModelId(id) { return parseFloat(id); }

  get url() { return '/bookings'; }
  get singular() { return 'booking'; }
  get plural() { return 'bookings'; }

  get Model() { return BookingModel; }
}

export default BookingsState;



// WEBPACK FOOTER //
// ./spa/state/bookings.jsx